export const environment = {
    production: false,
    stage: true,
    development: false,
    api: "https://staging.app.v3.custm.com.au/api/"
};
